/*eslint-disable*/
import state from "@/store/state"

/**
 * @module vuex/getters
 */
export default {
   
}
